import { useNavigate } from 'react-router-dom';
import { useModal } from '../hooks/useModal';
import { Landmark } from 'lucide-react';
import kakaoImage from '../assets/kakao.webp';

const RegisterBankModal: React.FC<{
  handleOpenTransferConfirmModal: (channel: string | null) => void;
}> = ({
  handleOpenTransferConfirmModal,
}) => {
  const navigate = useNavigate();
  const { closeModal } = useModal();

  const handleAccountRegister = () => {
    closeModal();
    navigate('/profile');
  };

  const handleKakaopayRegister = () => {
    closeModal();
    navigate('/profile/link-kakaopay');
  };

  const handleAlreadyReceived = () => {
    closeModal();
    handleOpenTransferConfirmModal(null);
  };

  return (
    <div className="w-full flex flex-col">
      <h2 className="text-[22px] font-bold mb-4">송금받기</h2>
      <p className="text-gray-600 mb-4">
        계좌번호나 카카오페이를 등록하면,<br />
        상대방이 원터치 송금을 할 수 있어요.
      </p>
      
      <div className="w-full flex flex-col gap-2 mb-3">
        <button 
          className="w-full py-2.5 font-bold text-lg bg-gray-200 text-gray-800 rounded-xl flex items-center justify-center gap-2 pr-4"
          onClick={handleAccountRegister}
        >
          <Landmark className="w-4 h-4 inline-block" />
          계좌번호 등록
        </button>
        <button 
          className="w-full py-2.5 font-bold text-lg bg-[#FEE500] text-[#333333] rounded-xl flex items-center justify-center gap-2 pr-4"
          onClick={handleKakaopayRegister}
        >
          <img src={kakaoImage} alt="kakao" className="w-4 h-4 inline-block" />
          카카오페이 등록
        </button>
      </div>
      
      <p 
        className="text-gray-800 underline mt-1 cursor-pointer text-center underline-offset-4"
        onClick={handleAlreadyReceived}
      >
        이미 송금을 받았나요?
      </p>
    </div>
  );
};

export default RegisterBankModal;